import React from "react";
//#region types
import { DrillDownTableBaseRowProps } from "models/propTypes/simpleTableProps";
//#endregion
//#region components
import DrillDownTableBaseRow from "./baseRow";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const DrillDownTableDimensionTitleRow: React.FC<DrillDownTableBaseRowProps> = (props) => {
  return <DrillDownTableBaseRow {...props} className={clsx(cssExports.dimensionTitle, props.className)} />;
};

export default DrillDownTableDimensionTitleRow;
